

<template>
  <div>
    <mensajeSistema></mensajeSistema>
    <v-row>
      <v-col cols="12" class="d-flex gap-10px">
        <v-select dense label="Nivel" :items="listNivel" item-value="id" outlined item-text="desc_nivel" hide-details
          v-model="id_nivel" style="max-width: 200px;" :rules="validationRules.validateCampo"></v-select>
          <v-select dense label="Turno" :items="turnos" item-value="id" outlined item-text="desc_turno" hide-details
          v-model="id_turno" style="max-width: 200px;" :rules="validationRules.validateCampo"
          @change="SearchHorario()">
         </v-select>
         <span style="font-size: 16px; color: gray;" class="mt-2">Por favor, elija un nivel y turno para consultar o agregar el horario.</span>
      </v-col>
      <v-col cols="12">
        <v-card outlined>
          <v-card-title>
            <v-chip label>
              Configuración de horario.
            </v-chip>
            <v-spacer />
            <ButtonComp icon-but="fas fa-sync-alt" class-color="green" tooltipText="Recargar los filtros"
              @click="cleanFiltro()" />
          </v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col cols="12" md="2">
                <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :nudge-right="40"
                  :return-value.sync="time" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="horaEntradaAMPM" label="Hora de entrada"
                      prepend-icon="mdi-clock-time-four-outline" readonly v-bind="attrs" v-on="on" @change="postHorarioAcademico"
                      :disabled="!nivelYTurnoSeleccionados" class="mt-7" >
                    </v-text-field>
                  </template>
                  <v-time-picker v-if="menu" v-model="horaEntrada" full-width format="ampm"
                  @click:minute="$refs.menu.save(time)" >
                </v-time-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="2">
                <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                  :return-value.sync="time" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="horaSalidaAMPM" label="Hora de salida"
                      prepend-icon="mdi-clock-time-four-outline" readonly v-bind="attrs" v-on="on" @change="postHorarioAcademico"
                      :disabled="!nivelYTurnoSeleccionados" class="mt-7" >
                    </v-text-field>
                  </template>
                  <v-time-picker v-if="menu2" v-model="horaSalida" full-width format="ampm"
                    @click:minute="$refs.menu2.save(time)" >
                  </v-time-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="3">
                <v-select class="mt-7" prepend-icon="mdi-clock-time-four-outline"
                label="Duración de la hora ácademica (minutos)" :disabled="!nivelYTurnoSeleccionados" @change="postHorarioAcademico"
                :items="duracionAcademica" v-model="duracionMinutos" return-object item-text="text"
                item-value="value" >
              </v-select>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field prepend-icon="mdi-clock-time-four-outline" v-model="primeraHora"
                :disabled="!nivelYTurnoSeleccionados" label="Formación (minutos)"
                placeholder="00 min" class="mt-7" :maxlength="2" :rules="duracionRules" 
                @change="postHorarioAcademico">
                <template v-slot:prepend>
                  <span class="prefijo-horas">00:</span>
                </template>
              </v-text-field>
              </v-col>
              <v-col cols="12" md="2" class="d-flex align-center justify-center">
                <ButtonComp normal-button="" classColor="green" dark :disabled="!valid" @click="submitForm" iconBut="fas fa-save"
                  textButton="Guardar horario" />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

      </v-col>
      <v-col cols="12" md="6">
        <v-card outlined>
          <v-card-title>
            <v-chip label>
              Registro de horario
            </v-chip>
          </v-card-title>
          <v-card-text>
            <v-row align="center">
              <v-col cols="12" v-if="rowData < 1">
                <v-card outlined>
                  <v-card-text>
                    <div style="min-height: 300px;" class="d-flex justify-center align-center text-center">
                      Sin registros del Horario
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col v-else class="d-flex justify-center">
                <ag-grid-vue class="ag-theme-balham" style="width: 1100px; height: 400px" :columnDefs="columnDefs"
                  :rowData="rowData">
                </ag-grid-vue>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
       
          <v-card outlined>
            <v-card-title>
              <v-chip label>
                Configuración de los recreos
              </v-chip>
              <v-spacer />
              <ButtonComp v-if="Addbutton" icon-but="fas fa-plus" @click="Addrecreo2()" class-color="primary"
                tooltip-text="Añadir recreo" :disabled="disableButton" />
            </v-card-title>
            <v-card-text>
              <v-form>
              <v-row>
                <v-col cols="12">
                  <v-card outlined>
                    <v-card-title class="text-subtitle-2"> 
                      Recreo
                      <v-spacer />
                      <!-- <ButtonComp iconBut="fas fa-save" tooltip-text="Guardar recreo" class-color="primary" /> -->
                    </v-card-title>
                    <v-card-text>
                    
                        <v-form ref="form" v-model="valid">
                        <v-col cols="12" md="12">
                         
                          <v-text-field class="pa-5" dense label="Nombre del recreo" v-model="nombre_recreo" :disabled="!nivelYTurnoSeleccionados"
                            ></v-text-field>
                        </v-col>
                        <v-row>

                          <v-col cols="12" md="6">
                            <v-select @change="changeRecreo1()" v-model="horaInicioRecreo" label="Inicio del recreo"
                            prepend-icon="mdi-clock-time-four-outline" :disabled="!nivelYTurnoSeleccionados"
                            :items="horasDisponibles"  item-text="horaInicio" 
                            item-value="horaInicio" ></v-select>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field prepend-icon="mdi-clock-time-four-outline" v-model="duracionRecreo" :disabled="!nivelYTurnoSeleccionados"
                            label="Duración del recreo (minutos)" :maxlength="2" :rules="[validateNumberRange]">
                            <template v-slot:prepend>
                              <span class="prefijo-horas">00:</span>
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>
                      </v-form>
                    

                    </v-card-text>
                  </v-card>
                </v-col>
              
                <v-col cols="12" v-if="recreo2_reg === true">
                  <v-card outlined>
                    <v-card-title class="text-subtitle-2">
                      Recreo 2
                      <v-spacer />
                      <!-- <ButtonComp icon-but="fas fa-save" class-color="primary" @click="cerrarModal3"
                      tooltip-text="Guardar 2do recreo" /> -->
                    </v-card-title>
                    <v-card-text>
                      <v-row dense>
                        <v-col cols="12">
                          <v-text-field class="pa-5" label="Nombre del recreo" v-model="nombre_recreo2"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-select v-model="horaInicioRecreo2" label="Inicio del recreo"
                            prepend-icon="mdi-clock-time-four-outline" :items="horasDisponibles" :item-disabled="item => item.deshabilitado"
                            item-text="horaInicio" 
                             item-value="horaInicio" class="pa-2 mt-1"></v-select>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field prepend-icon="mdi-clock-time-four-outline" v-model="duracionRecreo2"
                            label="Duración del recreo (minutos)" class="mt-2" :maxlength="2" :rules="[validateNumberRange]">
                            <template v-slot:prepend>
                              <span class="prefijo-horas">00:</span>
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
               </v-form>
            </v-card-text>
          </v-card>
      </v-col>

    </v-row>

  </div>
</template>

<script>
import { mapMutations } from "vuex";
import axios from "../../helpers/axios";
import { AgGridVue } from "ag-grid-vue";
import ButtonComp from "../../components/ComponentsEst/TableButtonComp.vue";
import { validationRules } from "../../helpers/validatorHelpers";




export default {
  props: {
    diaHabil: Array,
  },
  components: {
    ButtonComp,
    AgGridVue,
  },
  data() {
    return {
      events: [],
      listNivel: [],
      turnos: [],
      id_nivel: "",
      id_turno: "",
      diasSemana: [0, 1, 2, 3, 4, 5, 6],
      dayMinWidth: 100,
      horaEntrada: "0:00",
      horaSalida: "0:00",
      duracionHora: "0:00",
      duracionMinutos:"",
      duracionAcademica:[30, 35, 40, 45, 50, 55],
      primeraHora: "",
      duracionRecreo: "",
      duracionRecreo2: "",
      horaInicioRecreo: "00:00",
      horaInicioRecreo2: "00:00",
      nombre_recreo: "",
      nombre_recreo2: "",
      disableButton: false,
      Addbutton: false,
      time: "",
      menu: false,
      menu2: false,
      menu3: false,
      modal2: false,
      modal3: false,
      activePicker: "MINUTE",
      allowedHours: [0],
      valid: true,

      duracionRules: [
        (v) => (!isNaN(parseFloat(v)) && isFinite(v)) || "Debe ser un número",
        (v) => (v >= 0 && v <= 59) || "El valor debe estar entre 0 y 59",
      ],
      horarioAcademico: [],
      //modelos para consultar
      id_nivelConsultar: "",
      id_turnoConsultar: "",

      //modal confirmacion
      
      recreo2_reg: false,
      dialog_confirm2: false,
      eventoConfirm: "",
      errorMensaje: "",

      // ag grid
      columnDefs: null,
      rowData: null,

      diasSemanas: [],
      diasHabiles: [],
      horasDisponibles: [],

      //calculo de las horas
      horaInicio: [],
      horaFin: "",
      hora: []

    };
  },

  mounted() {
    this.GetNivel();
    this.getTurnos();
    this.getDiasDeLaSemana();
    this.cargarDatosYObtenerDiasHabiles();
  },

  watch: {
    // Cuando el usuario selecciona una hora desde el selector
    time(newTime) {
      this.duracionHora = newTime.split(":")[1] || "00:00";
    }
  },

  computed: {

    validationRules() {
      return validationRules;
    },

    horaEntradaAMPM() {
      const [hora, minutos] = this.horaEntrada.split(":");
      let ampm = "am";
      let hora12 = parseInt(hora);

      if (hora12 >= 12) {
        ampm = "pm";
        if (hora12 > 12) {
          hora12 -= 12;
        }
      }
      return `${hora12}:${minutos} ${ampm}`;
    },

    nivelYTurnoSeleccionados() {
      return this.id_nivel && this.id_turno;
    },

    horaSalidaAMPM() {
      const [hora, minutos] = this.horaSalida.split(":");
      let ampm = "am";
      let hora12 = parseInt(hora);

      if (hora12 >= 12) {
        ampm = "pm";
        if (hora12 > 12) {
          hora12 -= 12;
        }
      }
      return `${hora12}:${minutos} ${ampm}`;
    },


  },

  methods: {
    ...mapMutations("mensajeSis", ["setEnviarMens"]),

    cleanFiltro() {
      this.Addbutton = false,
        (this.horaEntrada = "0:00"),
        (this.horaSalida = "0:00");

        (this.duracionMinutos = ""),
        (this.primeraHora = ""),
        (this.duracionRecreo = ""),
        (this.duracionRecreo2 = ""),
        (this.horaInicioRecreo = "00:00"),
        (this.horaInicioRecreo2 = "00:00");
        (this.nombre_recreo = "");
        (this.nombre_recreo2 = "");
    },

    validateNumberRange(value) {
    if (!value || value < 10 || value > 59) {
      return 'El valor debe estar entre 10 y 59';
    }
    return true;
  },
  

    async Addrecreo2() {
      this.recreo2_reg = true
      this.postHorarioAcademico('recreo2')
    },

    formatTime(variable) {
      variable = variable.replace(/[^0-9:]/g, "");

      // Asegura que la cadena tenga un solo ":"
      const parts = variable.split(":");
      if (parts.length > 2) {
        parts.pop();
      }
      variable = parts.join(":");

      // Actualiza la variable original
      if (variable === this.duracionHora) {
        this.duracionHora = variable;
      } else if (variable === this.primeraHora) {
        this.primeraHora = variable;
      } else if (variable === this.duracionRecreo) {
        this.duracionRecreo = variable;
      } else if (variable === this.duracionRecreo2) {
        this.duracionRecreo2 = variable;
      }
    },


    async GetNivel() {
      let params = {
        id_colegio_adm_nivel: sessionStorage.id_colegio,
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
      };
      try {
        let response = await axios.post("/administrativo/nivel/niveladmin/", params);
       
        this.listNivel = response.data;
       
      
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async getTurnos() {
      try {
        let response = await axios.get("/mantenimiento/turnos");
        this.turnos = response.data;
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },


    async changeRecreo1() {
      this.Addbutton = true
      this.disableButton = false
      this.recreo2_reg = false
      this.horaInicioRecreo2 = "00:00"
      this.duracionRecreo2 = ""
      this.nombre_recreo2 = ""
    },



    async SearchHorario() {
     await this.cargarDatosYObtenerDiasHabiles();
      this.cleanFiltro();
      this.recreo2_reg = false;
      this.rowData = null;
      
       // Validar si this.diasHabiles no existe o su longitud es menor o igual a 0
      if (this.diasHabiles.length <= 0) {
        this.setEnviarMens({
          tipo: "W",
          mensaje: "No se puede configurar horario, sin antes asignar los dias habiles en el calendario.",
          tiempo: null,
        });
        
        return; 
      }

      // Llamar a la función getHorarioAcademico() para obtener el horario académico
      this.getHorarioAcademico();
    },

    validarCampos() {
      const campos = [
        this.id_nivel,
        this.id_turno,
        this.horaEntrada,
        this.horaSalida,
      ];

      return campos.every((campo) => campo !== null && campo !== "");
    },

    async getHorarioAcademico() {

      const idColegio = parseInt(sessionStorage.getItem("id_colegio"));

      try {
        let response = await axios.get(
          `/administrativo/horarioAcademico/${idColegio}/${this.id_nivel}/${this.id_turno}`
        );

        this.horarioAcademico = response.data;
        if (this.horarioAcademico && this.horarioAcademico.length > 0 && this.horarioAcademico[0].hora_salida !== "00:00:00") {
          
          this.horaEntrada = this.horarioAcademico[0].hora_entrada;
          this.horaSalida = this.horarioAcademico[0].hora_salida;
          // Esto extraerá '45' y lo convertirá a número en duracion minutos :)
          let duracion = this.horarioAcademico[0].duracion_hora_academica;
         
          let minutos =parseInt(duracion.split(":")[1]);
          this.duracionMinutos = minutos;
          
          //aca repito la misma operacion para la hora de formacion
          let formacion = this.horarioAcademico[0].hora_de_formacion;
          let minutos2 = parseInt(formacion.split(":")[1]);
          this.primeraHora = minutos2;
          // y por ultimo el tiempo de recreo
          let tiempoRecreo = this.horarioAcademico[0].tiempo_de_recreo;
          let minutosRecreo = parseInt(tiempoRecreo.split(":")[1]);
          this.duracionRecreo = minutosRecreo;
          let tiempoRecreo2 = this.horarioAcademico[0].tiempo_de_recreo2;
          let minutosRecreo2 = parseInt(tiempoRecreo2.split(":")[1]);
          this.duracionRecreo2 = minutosRecreo2;
          let horaInicioRecreo1 = new Date(`2000-01-01T${this.horarioAcademico[0].inicio_recreo1}`);
          this.horaInicioRecreo = horaInicioRecreo1.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });

          // Formatear la hora de inicio del recreo 2
          let horaInicioRecreo2 = new Date(`2000-01-01T${this.horarioAcademico[0].inicio_recreo2}`);
          this.horaInicioRecreo2 = horaInicioRecreo2.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });

          this.nombre_recreo = this.horarioAcademico[0].titulo_recreo1;
          this.nombre_recreo2 = this.horarioAcademico[0].titulo_recreo2;


          if (this.horarioAcademico[0].duracion_hora_academica === '00:00') {
           
            this.disableButton = true
          } else if (this.horaInicioRecreo === '00:00') {
           
            this.recreo2_reg = false
            this.disableButton = true;
          } else {
           
            this.recreo2_reg = false
            this.Addbutton = true
            this.disableButton = false
          }

          if (this.horaInicioRecreo2 === '00:00' && this.horaInicioRecreo === '00:00') {
            this.Addbutton = true
            this.disableButton = false
            this.recreo2_reg = false
          } else {
            this.disableButton = true
            this.recreo2_reg = true
          }

          this.calcularHora();

        } else {

          this.disableButton = true;

          this.setEnviarMens({ tipo: "W", mensaje: `No existe registro para este nivel y turno.`, tiempo: null });
        }

      } catch (error) {

        this.errorMensaje = "Error: No existe registro para este nivel y turno.";
      }
    },

    // metodo para enviar los datos al backend
   
    validarCampos2() {
    // Lista de campos importantes a validar
    if (!this.horaEntrada) {
      return false;
    }
    if (!this.horaSalida) {
      return false;
    }
    if (!this.duracionMinutos) {
      return false;
    }
    return true;
  },

  // Función para enviar datos al backend
  async postHorarioAcademico() {
    // Formatear correctamente las duraciones
    const duracionHoraAcademica = `00:${this.duracionMinutos}`;
    const duracionFormacion = `00:${this.primeraHora}` ;
    const duracionRecreo = `00:${this.duracionRecreo}`;
    const duracionRecreo2 = `00:${this.duracionRecreo2}`;

    // Crear el objeto de datos para enviar
    const objetData = {
      id_colegio: parseInt(sessionStorage.getItem("id_colegio")),
      id_ano_lectivo: parseInt(sessionStorage.getItem("id_ano_lectivo")),
      id_nivel: this.id_nivel,
      id_turno: this.id_turno,
      hora_entrada: this.horaEntrada,
      hora_salida: this.horaSalida,
      duracion_hora_academica: duracionHoraAcademica,
      hora_de_formacion: duracionFormacion,
      tiempo_de_recreo: duracionRecreo,
      inicio_recreo1: this.horaInicioRecreo,
      titulo_recreo1: this.nombre_recreo,
      inicio_recreo2: this.horaInicioRecreo2,
      titulo_recreo2: this.nombre_recreo2,
      tiempo_de_recreo2: duracionRecreo2,
    };

    // Validar campos importantes antes de enviar
    if (!this.validarCampos2()) {
      return; // Salir del método si los campos no son válidos
    }

    // Intentar enviar los datos a la API
    try {
      await axios.post(
        "/administrativo/horarioAcademico",
        objetData
      );
      this.getHorarioAcademico(); // Actualizar el horario si se guarda correctamente
    } catch (error) {
      this.setEnviarMens({ tipo: "E", mensaje: `Error: ${error.message}`, tiempo: null });
    }
  },

    
    submitForm() {

        if (!this.horaInicioRecreo || !this.duracionRecreo || !this.nombre_recreo) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: "No se puede guardar un horario sin recreo. Por favor, asegúrate de que la hora de inicio, duración y nombre del recreo estén definidos.",
          tiempo: null,
        });
        return; // Salir del método si alguna condición no se cumple
      }
      if (this.$refs.form.validate()) {
        // El formulario es válido, procede a enviar la información
        this.postHorarioAcademico();
        this.getHorarioAcademico();

        
      } else {
       
        console.log('Formulario inválido');
      }
    },



    sumarHoras(startTime, formacion) {
      const startTimeSegundos = this.convertirATiempoEnSegundos(startTime);
      const formacionSegundos = this.convertirATiempoEnSegundos(formacion);

      // Sumar los segundos
      const nuevaHoraEnSegundos = startTimeSegundos + formacionSegundos;

      // Convertir de nuevo a formato "HH:mm:ss"
      const nuevaHora = this.convertirASegundosATiempo(nuevaHoraEnSegundos);

      return nuevaHora;
    },

    convertirATiempoEnSegundos(tiempo) {
      const partesTiempo = tiempo.split(":");
      const horas = parseInt(partesTiempo[0], 10);
      const minutos = parseInt(partesTiempo[1], 10);
      const segundos = parseInt(partesTiempo[2], 10);
      return horas * 3600 + minutos * 60 + segundos;
    },

    convertirASegundosATiempo(segundos) {
      const horas = Math.floor(segundos / 3600);
      segundos %= 3600;
      const minutos = Math.floor(segundos / 60);
      segundos %= 60;

      return `${String(horas).padStart(2, "0")}:${String(minutos).padStart(
        2,
        "0"
      )}:${String(segundos).padStart(2, "0")}`;
    },

    //metodo que consulta los dias de la semana en la tabla
    async getDiasDeLaSemana() {
      try {
        let response = await axios.get("/mantenimiento/diasSemanas");
        this.diasSemanas = response.data;
        
      } catch (e) {
        console.log(e);
      }
    },
    // metodo que consulta los dias habiles de la semana.

    async getDiasHabiles() {
      let id_colegio = sessionStorage.id_colegio;

      try {
        let response = await axios.get(
          `/administrativo/calendarioAcademico/${id_colegio}`
        );
        this.diasHabiles = response.data[0].dias_seleccionados;
         
      } catch (error) {
        // console.log(error);
      }
    },

    //metodo para obtener loos nombres de los dias habiles .

    obtenerNombresDiasHabiles() {
      if (!this.diasHabiles || !this.diasSemanas) {
        return [];
      }

      this.nombresDiasHabiles = this.diasSemanas
        .filter((diaSemana) => this.diasHabiles.includes(diaSemana.id))
        .map((diaHabil) => diaHabil.nombre_dia);

      // console.log("nombre", this.nombresDiasHabiles);
      return this.nombresDiasHabiles;
    },

    async cargarDatosYObtenerDiasHabiles() {
      try {
        await Promise.all([this.getDiasHabiles(), this.getDiasDeLaSemana()]);
        this.obtenerNombresDiasHabiles();
        this.actualizarColumnas();
      } catch (error) {
        console.error("Error al cargar los datos:", error);
      }
    },

    // aca actualizo las columnas dinamicas.

    actualizarColumnas() {
      if (!Array.isArray(this.nombresDiasHabiles)) {
        return;
      }

      // Columna fija para el horario
      const columnasDinamicas = [
        { field: "hora", headerName: "Hora", pinned: "left", width: 100 },
      ];

      // Y luego para los días hábiles:
      this.nombresDiasHabiles.forEach((dia) => {
        columnasDinamicas.push({ headerName: dia, field: dia.toLowerCase(), width: 135 });
      });

      // Luego establece las columnDefs actualizadas y refresca el grid
      this.columnDefs = columnasDinamicas;
      if (this.gridApi) {
        this.gridApi.setColumnDefs(this.columnDefs);
      }
    },

    calcularHora() {
      this.horasDisponibles = [];

      this.horaInicio = this.horaEntrada.split(':').slice(0, 2).join(':'); // Formatea para quitar segundos
      this.horaFin = this.horaSalida.split(':').slice(0, 2).join(':'); // Formatea para quitar segundos
      
      // Reiniciar el array de horas para cada cálculo
      this.hora = [];

      // Si hay primera hora, sumarla a la hora de entrada y crear el bloque de formación
      if (this.primeraHora !== null && !isNaN(this.primeraHora)) {
        const horasPrimera = Math.floor(this.primeraHora / 60);
        const minutosPrimera = this.primeraHora % 60;
        let nuevaHora = new Date(2022, 0, 1, parseInt(this.horaInicio.split(':')[0]) + horasPrimera, parseInt(this.horaInicio.split(':')[1]) + minutosPrimera);

        // Formatear la hora de fin
        let horas = nuevaHora.getHours().toString().padStart(2, '0');
        let minutos = nuevaHora.getMinutes().toString().padStart(2, '0');
        this.horaFin = `${horas}:${minutos}`;
        
        if (this.horaInicio == this.horaFin) {
          console.log("Son iguales")

        } else {
          
          // Agregar el bloque de formación inicial al array
          this.hora.push({ hora: `${this.horaInicio} - ${this.horaFin}`, tipo: 'Formación', horaInicio: this.horaInicio });

          // Actualizar horaInicio para el siguiente bloque después de la formación
          this.horaInicio = this.horaFin;

        }

      }

      let horaInicioSiguienteBloque = this.horaFin; // Inicializamos la hora de inicio del siguiente bloque con la hora de fin inicial
      //se agrega limit al número de bucles
      let loopLimit = 0
      while (horaInicioSiguienteBloque < this.horaSalida && loopLimit < 100) {
        
        let horaInicioSiguienteBloqueDate = new Date(2022, 0, 1, parseInt(horaInicioSiguienteBloque.split(':')[0]), parseInt(horaInicioSiguienteBloque.split(':')[1]));
        let tipoBloque = '-';

        // Preparar variables para recreos
        let horaInicioRecreoDate = new Date(2022, 0, 1, parseInt(this.horaInicioRecreo.split(':')[0]), parseInt(this.horaInicioRecreo.split(':')[1]));
        let horaInicioRecreo2Date = new Date(2022, 0, 1, parseInt(this.horaInicioRecreo2.split(':')[0]), parseInt(this.horaInicioRecreo2.split(':')[1]));
        let nuevaHoraFin;

        // Verificar si estamos en el horario de inicio del primer recreo
        
        if (horaInicioRecreoDate.getTime() === horaInicioSiguienteBloqueDate.getTime()  && Number(this.duracionRecreo) > 0) {
          nuevaHoraFin = new Date(horaInicioRecreoDate.getTime() + this.duracionRecreo * 60000);
          tipoBloque = this.nombre_recreo;
          
        }
        // Verificar si estamos en el horario de inicio del segundo recreo
        else if (horaInicioRecreo2Date.getTime() === horaInicioSiguienteBloqueDate.getTime() && Number(this.duracionRecreo2) > 0) {
          nuevaHoraFin = new Date(horaInicioRecreo2Date.getTime() + this.duracionRecreo2 * 60000);
          tipoBloque = this.nombre_recreo2;

        }
        // Calcular la nueva hora de fin para bloques regulares
        else {
          nuevaHoraFin = new Date(horaInicioSiguienteBloqueDate.getTime() + this.duracionMinutos * 60000);

        }

        // Formatear la nueva hora de fin
        let horas = nuevaHoraFin.getHours().toString().padStart(2, '0');
        let minutos = nuevaHoraFin.getMinutes().toString().padStart(2, '0');
        nuevaHoraFin = `${horas}:${minutos}`;

        // Verificar si la nueva hora de fin es mayor que la hora de salida
        loopLimit++
        if (nuevaHoraFin <= this.horaSalida) {
          this.hora.push({
            hora: `${horaInicioSiguienteBloque} - ${nuevaHoraFin}`,
            tipo: tipoBloque,
            horaInicio: horaInicioSiguienteBloque
          });
          
          horaInicioSiguienteBloque = nuevaHoraFin; // Actualizar para el siguiente bloque
        } else {
          
          break; 
        }
      }

      this.horasDisponibles = this.hora.map((bloque) => ({
            horaInicio: bloque.horaInicio,
            minutos: this.horaAMinutos(bloque.horaInicio),
            deshabilitado: false
          }));

          const minutosInicioRecreo = this.horaAMinutos(this.horaInicioRecreo);
          this.horasDisponibles = this.horasDisponibles.map(bloque => ({
            ...bloque,
            deshabilitado: bloque.minutos <= minutosInicioRecreo
          }));
  
          this.horasDisponibles.shift();
           this.newData = this.hora.map((item) => ({
            hora: item.hora,
            horaInicio: item.horaInicio,
            lunes: item.tipo,
            martes: item.tipo,
            miércoles: item.tipo,
            jueves: item.tipo,
            viernes: item.tipo,
            sábado: item.tipo,
            domingo: item.tipo,
      }))
    
      this.rowData = this.newData

    },
    horaAMinutos(hora) {
    const [horas, minutos] = hora.split(":").map(Number);
    return horas * 60 + minutos;
  },

    validateRecreo(){
      return this.nombre_recreo && this.horaInicioRecreo.includes(":") && this.duracionRecreo >= 10 && this.duracionRecreo <= 59
    }

  }
}

</script>

<style scoped>
.prefijo-horas {
  margin-left: 6px;
  margin-top: 4px;
}
</style>
